import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { firebaseReducer } from 'react-redux-firebase';
import changeStudentFilter from '../actions';
import addStudents from '../actions';
import addLogs from '../actions';
import yearChange from '../actions';
import logYears from '../actions';

const initialStudentFilter = {
  id: 'all',
  name: ''
};

function studentFilter(state = initialStudentFilter, action) {
  switch (action.type) {
    case 'CHANGE':
      return Object.assign({}, state, {
        id: action.id,
        name: action.name
      });
    default:
      return state;
  }
}

function changeYear(state = {}, action) {
  switch (action.type) {
    case 'CHANGE_YEAR':
      return Object.assign({}, state, {
        year: action.year,
        allYears: action.allYears
      });
    default:
      return state;
  }
}

const initialClassFilter = {
  grade: 'All',
  category: 'All',
  subject: { id: '', name: 'All' },
  teacher: { id: '', name: 'All' }
};

const initialProjectFilter = {
  name: '',
  reaction: '',
  type: '',
  stage: '',
  submit: ''
};

function classFilter(state = initialClassFilter, action) {
  switch (action.type) {
    case 'grade':
      return Object.assign({}, state, {
        grade: action.value
      });
    case 'category':
      return Object.assign({}, state, {
        category: action.value
      });
    case 'subject':
      return Object.assign({}, state, {
        subject: action.value
      });
    case 'teacher':
      return Object.assign({}, state, {
        teacher: action.value
      });
    case 'reset':
      return initialClassFilter;
    default:
      return state;
  }
}

function projectFilter(state = initialProjectFilter, action) {
  switch (action.type) {
    case 'name':
      return Object.assign({}, state, {
        name: action.value
      });
    case 'reaction':
      return Object.assign({}, state, {
        reaction: action.value
      });
    case 'type':
      return Object.assign({}, state, {
        type: action.value
      });
    case 'stage':
      return Object.assign({}, state, {
        stage: action.value
      });
    case 'submit':
      return Object.assign({}, state, {
        submit: action.value
      });
    default:
      return state;
  }
}

const initialStudents = {
  students: ''
};

function studentsOfSchool(state = initialStudents, action) {
  switch (action.type) {
    case 'ADD_STUDENTS':
      return Object.assign({}, state, {
        students: action.students
      });
    default:
      return state;
  }
}

function teachersOfSchool(state = {}, action) {
  switch (action.type) {
    case 'ADD_TEACHERS':
      return Object.assign({}, state, {
        teachers: action.teachers
      });
    default:
      return state;
  }
}

function addClasses(state = {}, action) {
  switch (action.type) {
    case 'ADD_CLASSES':
      return Object.assign({}, state, {
        classes: action.classes
      });
    default:
      return state;
  }
}

const initialLogs = {
  logs: ''
};

function relevantLogs(state = initialLogs, action) {
  switch (action.type) {
    case 'ADD_LOGS':
      return Object.assign({}, state, {
        logs: action.logs
      });
    default:
      return state;
  }
}

function allYears(state = {}, action) {
  switch (action.type) {
    case 'ADD_YEARS':
      return Object.assign({}, state, {
        years: action.years
      });
    default:
      return state;
  }
}

const changeClass_init = {
  id: 'All',
  subject: '',
  name: '',
  grade: '',
  subjectId: '',
  students: []
};

function changeClass(state = changeClass_init, action) {
  switch (action.type) {
    case 'CHANGE_CLASS':
      return Object.assign({}, state, {
        id: action.id,
        subject: action.subject,
        name: action.name,
        grade: action.grade,
        subjectId: action.subjectId,
        students: action.students
      });
    default:
      return state;
  }
}

export default combineReducers({
  studentFilter: studentFilter,
  classFilter: classFilter,
  studentsOfSchool: studentsOfSchool,
  teachersOfSchool: teachersOfSchool,
  classes: addClasses,
  selectedClass: changeClass,
  relevantLogs: relevantLogs,
  firebase: firebaseReducer,
  router: routerReducer,
  currentYear: changeYear,
  allYears: allYears,
  projectFilter: projectFilter
});



// WEBPACK FOOTER //
// ./src/reducers/index.js